angular.module('elfium').controller('elfiumSortController', ['$scope', '$element',
    function ($scope, $element) {
        var that = this;
        that.invertedSort = true;
        that.$onInit = function () {
        	$element.addClass('pointer');
        };
        that.sort = function () {
        	$scope.$apply(function () {
        		that.invertedSort = !that.invertedSort;
        		$scope.currentSort.reverse = that.invertedSort;
                $scope.currentSort.comparator = $scope.comparator ? function (v1, v2) {
                    return $scope.comparator({
                        v1: v1,
                        v2: v2
                    });
                } : undefined;
            	$scope.currentSort.field = $scope.elfiumSort;
        	});
        };
        $scope.getClass = function () {
            var resultClass = '';
            if ($scope.currentSort.field && $scope.currentSort.field == $scope.elfiumSort) {
                if (that.invertedSort) {
                    resultClass = 'fa-sort-desc';
                } else {
                    resultClass = 'fa-sort-asc';
                }                
            } else {
                resultClass = 'fa-sort';
            }
            return resultClass;
        };
        that.sortHasChanged = function () {
            that.invertedSort = true;
        };
        $element.on('click', that.sort);
        that.$onDestroy = function () {
        	$element.off('click', that.sort);
        }
        $scope.$watch(function () {
            return $scope.currentSort.field;
        }, that.sortHasChanged);
    }
]);


// WEBPACK FOOTER //
// ./src/app/components/elfium/elfiumSortController.ts